import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/jotai/esm/react/utils.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/[lang]/(no-footer)/s/SearchSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/lib/components/GoogleTagManagerViewPage/GTMViewPageEvent.tsx");
